import { __awaiter } from "tslib";
import { default as consoleEvents } from "@pb/utils/consoleEvents";
import { default as request } from "@pb/utils/request";
import { default as getCookie } from "@pb/utils/getCookie";
import { API_BASE_URL, PRESENTATION_ATTRIBUTES, PRESENTATION_ATTRIBUTES_WITH_LOCALE, } from '../constants';
import normalizeSimilarItemsProduct from './normalizeSimilarItemsProduct';
const getPresentationAttributes = (market) => PRESENTATION_ATTRIBUTES.map((attr) => PRESENTATION_ATTRIBUTES_WITH_LOCALE.includes(attr) ? `${attr}_${market.toLowerCase()}` : attr).join(',');
/**
 *
 * @param category_codes Current category path (eg. 'men_trousers_all')
 * @param market_locale Current market locale (eg. 'sv_se')
 * @param market Current market (eg. 'SE')
 * @param product_key Currently viewed Product code (eg. '1092741002')
 * @param window_first Result start offset
 * @param window_last  Number of results
 * @returns
 */
const getSimilarItems = (category_codes, market_locale, market, product_key, window_first = 1, window_last = 8) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const cookieLocaleSplit = (_a = getCookie('HMCORP_locale')) === null || _a === void 0 ? void 0 : _a.split(/[-_]/);
    const regionMarket = cookieLocaleSplit ? cookieLocaleSplit.pop() : market;
    try {
        const apiParams = {
            'esales.customerKey': getCookie('praCookie') || '523fa5f1-dabb-4d62-833d-1106a39e379b',
            filter: `category_codes:'${category_codes}' AND market_locale:'${market_locale}' AND v_currentlyForSaleOnSite:'true'`,
            'esales.sessionKey': getCookie('praCookie') || '523fa5f1-dabb-4d62-833d-1106a39e379b',
            window_first: window_first.toString(),
            window_last: window_last.toString(),
            'esales.market': regionMarket,
            market_locale,
            product_key,
            presentation_attributes: getPresentationAttributes(regionMarket),
        };
        const queryParams = new URLSearchParams(apiParams);
        const { recommendBasedOnProduct } = yield request.get(`${API_BASE_URL}?${queryParams.toString()}`)
            .then((response) => response.data);
        return recommendBasedOnProduct[0].products.map((product) => normalizeSimilarItemsProduct(product, regionMarket));
    }
    catch (error) {
        consoleEvents.error('Error in getSimilarItems', error.toString());
    }
    return [];
});
export default getSimilarItems;
//# sourceMappingURL=getSimilarItems.js.map